import { Component, HostBinding, Input } from '@angular/core';

import { BETSLIP_SUMMARY_NUMPAD } from '../../models';

@Component({
    selector: 'bs-digital-summary-stake-keyboard',
    templateUrl: './summary-stake-keyboard.component.html',
    standalone: false,
})
export default class SummaryStakeKeyboardComponent {
    @HostBinding('class') className = 'summary-stake-keyboard';
    @Input() keypadId = BETSLIP_SUMMARY_NUMPAD;

    constructor() {}
}
